<div class="d-flex flex-wrap align-items-center gap-2 min-height">
  <ul class="nav nav-links flex-wrap">
    <li class="nav-item">
      <a class="nav-link active" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
        routerLink="/tenders">All</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
        routerLink="/tenders/active">Active</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
        routerLink="/tenders/past">Past</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}"
        routerLink="/tenders/draft">Drafts</a>
    </li>
  </ul>
  <div class="d-flex align-items-center ms-lg-auto tender-search-wrap">
    <div class="input-group">
      <input [(ngModel)]="term" (ngModelChange)="search()" type="text" class="form-control"
        placeholder="Filter tenders by name..." />
      <button class="btn btn-light" type="button" [disabled]="!term" (click)="clearTerm()">
        <i class="fas fa-times"></i>
      </button>
    </div>

  </div>
</div>